export class GatewayPayment {

    refNo: string;
    amount: number = 0;
    fromLocationCode: number;
    paymentType: string;
    type: string;
    gatewayPaymentResponseCode: number;
}
